import styled from 'styled-components';
import { colors } from 'Constants/Colors';

export const ResponseContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const inputLabel = {
  fontFamily: 'metropolis',
  fontSize: '1rem',
  fontWeight: 'bold',
};

export const answerTextInput = {};

export default {
  ResponseContainer,
  inputLabel,
};
